import { createActions, handleActions } from 'redux-actions';
import { Map } from 'immutable';

const initState = Map({
  hasAuthAccount: false,
  channelList: []
});

export const { setChannelList, setHasAuthAccount } = createActions({
  setChannelList: action => action,
  setHasAuthAccount: action => action
});

const channel = handleActions(
  {
    [setChannelList]: (state, action) => {
      const { data } = action.payload;
      return state.set('channelList', data);
    },
    [setHasAuthAccount]: (state, action) => {
      return state.set('hasAuthAccount', action.payload);
    }
  },
  initState
);

export default channel;
